<dashboardnav>

  <cradua-community
  [lgas]="lgas$ | async"
  [communities]="communities$ | async"

  (changeEmit)="onSubmitCommunity($event)"
  (deleteEvent)="onDeleteCommunity($event)"
  *ngIf="
  !(isLoadingLga$ | async ) &&
  !(isLoadingCommunity$ | async )
  "
  >
</cradua-community>

  <mrsoftapps-epims-reference-spinner
  *ngIf="
  (isLoadingLga$ | async ) ||
  (isLoadingCommunity$ | async )
  "
>
  </mrsoftapps-epims-reference-spinner>
</dashboardnav>